import Popper from '@material-ui/core/Popper';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { Flex, Padding } from './base/layout-components';
import Border from './base/Border';
import Text from './base/Text';
import { connect } from 'react-redux';
import { isBlurredSelector } from 'state/selectors/ui-state';
import { LBButton, LBXIcon } from '@linearb/buzz';

const Container = styled(Flex)`
  ${({ height }) => `height ${height}`};
  background: #ffffff;
  box-shadow: 0 0 34px rgba(59, 89, 152, 0.2);
  border-radius: 0.8rem;
  ${({ isBlurred }) => (isBlurred ? 'filter:blur(5px);' : '')};
`;

const StyledPopper = ({
  children,
  anchorEl,
  onClose,
  title = '',
  width = '69rem',
  height = '35.3rem',
  isBlurred,
  isTitleBorder = true,
  ...rest
}) => {
  return (
    <Popper
      {...rest}
      open={!!anchorEl}
      anchorEl={anchorEl}
      modifiers={{
        preventOverflow: {
          enabled: true,
          boundariesElement: 'viewport'
        }
      }}
    >
      <Container
        direction='column'
        width={width}
        height={height}
        isBlurred={isBlurred}
      >
        <Border
          {...(isTitleBorder
            ? { b: `1px solid ${getColor('chambray', 0.3)}` }
            : {})}
          height='auto'
        >
          <div className='p-4'>
            <div className='flex flex-row justify-between items-center'>
              <Text size='x-large' weight='500' color='abbey'>
                {title}
              </Text>
              <LBButton onClick={onClose} variant='ghost' size='icon'>
                <LBXIcon />
              </LBButton>
            </div>
          </div>
        </Border>

        <Padding
          padding='medium'
          {...(!isTitleBorder ? { t: 'no-space' } : {})}
          height='100%'
        >
          {children}
        </Padding>
      </Container>
    </Popper>
  );
};

const mapStateToProps = state => ({
  isBlurred: isBlurredSelector(state)
});

const mapDispatchToProps = state => ({});

export default connect(mapStateToProps, mapDispatchToProps)(StyledPopper);
